module.exports = __webpack_public_path__ + "static/media/card_new.24d0724d.pdn";